import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";

const forYouHeaderXl = require("../images/LP-znajdziemy-2560.jpg");
const forYouHeaderLg = require("../images/LP-znajdziemy-1920.jpg");
const forYouHeaderMd = require("../images/LP-znajdziemy-1366.jpg");
const forYouHeaderSm = require("../images/LP-znajdziemy-600.jpg");
const forYouHeaderXs = require("../images/LP-znajdziemy-360.jpg");

export const ForYouHeader = () => {
    const dispatch = useAppDispatch();
    const openModal = () => {
        dispatch(openForYouModal([OfferType.FLAT, OfferType.HOUSE]));
    };

    return (
        <section className={forYouHeader}>
            <Picture
                sources={[
                    {minWidthPX: 0, src: forYouHeaderXs, height: 553, width: 448},
                    {minWidthPX: 360, src: forYouHeaderSm, height: 553, width: 448},
                    {minWidthPX: 600, src: forYouHeaderMd, height: 553, width: 1366},
                    {minWidthPX: 1366, src: forYouHeaderLg, height: 553, width: 1919},
                    {minWidthPX: 1919, src: forYouHeaderXl, height: 553, width: 2560}
                ]}
                alt="header"
                className={forYouImageCss}
                fetchPriority="high"
            />

            <div className={forYouHeaderContentPositioner}>
                <Text variant="headline_6" as="h1" align="center" color="white">
                    Pomoc przy zakupie mieszkania
                </Text>
                <Text variant="headline_0" as="h2" align="center" color="white">
                    Przeprowadzimy Cię przez cały
                    <br />
                    proces poszukiwania i zakupu mieszkania
                </Text>
                <Text variant="body_copy_0" align="center" color="white">
                    Skorzystaj z usługi naszego konsultanta mieszkaniowego i znajdź mieszkanie szybko, wygodnie i bez stresu
                </Text>

                <Button variant="filled_primary" type="button" onClick={openModal} className={buttonStyle}>
                    Wyszukaj dla mnie
                </Button>
            </div>
        </section>
    );
};
// INFO: `height` and `breakpoints` has connection with picture size
const forYouHeader = css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    minHeight: "553px"
});

const forYouHeaderContentPositioner = css({
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "100%",
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    transform: "translate(-50%, -55%)",
    paddingX: 1.5
});

const forYouImageCss = css({
    "& img": {
        height: "100%",
        maxWidth: "initial"
    }
});

const buttonStyle = css({
    marginTop: 3
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";

const forYouHeaderXl = require("../images/LP-znajdziemy-2560.jpg");
const forYouHeaderLg = require("../images/LP-znajdziemy-1920.jpg");
const forYouHeaderMd = require("../images/LP-znajdziemy-1366.jpg");
const forYouHeaderSm = require("../images/LP-znajdziemy-600.jpg");
const forYouHeaderXs = require("../images/LP-znajdziemy-360.jpg");

export const ForYouHeader = () => {
    const dispatch = useAppDispatch();
    const openModal = () => {
        dispatch(openForYouModal([OfferType.FLAT, OfferType.HOUSE]));
    };

    return (
        <section className={forYouHeader}>
            <Picture
                sources={[
                    {minWidthPX: 0, src: forYouHeaderXs, height: 553, width: 448},
                    {minWidthPX: 360, src: forYouHeaderSm, height: 553, width: 448},
                    {minWidthPX: 600, src: forYouHeaderMd, height: 553, width: 1366},
                    {minWidthPX: 1366, src: forYouHeaderLg, height: 553, width: 1919},
                    {minWidthPX: 1919, src: forYouHeaderXl, height: 553, width: 2560}
                ]}
                alt="header"
                className={forYouImageCss}
                fetchPriority="high"
            />

            <div className={forYouHeaderContentPositioner}>
                <Text variant="headline_6" as="h1" align="center" color="white">
                    Pomoc przy zakupie mieszkania
                </Text>
                <Text variant="headline_0" as="h2" align="center" color="white">
                    Przeprowadzimy Cię przez cały
                    <br />
                    proces poszukiwania i zakupu mieszkania
                </Text>
                <Text variant="body_copy_0" align="center" color="white">
                    Skorzystaj z usługi naszego konsultanta mieszkaniowego i znajdź mieszkanie szybko, wygodnie i bez stresu
                </Text>

                <Button variant="filled_primary" type="button" onClick={openModal} className={buttonStyle}>
                    Wyszukaj dla mnie
                </Button>
            </div>
        </section>
    );
};
// INFO: `height` and `breakpoints` has connection with picture size
const forYouHeader = css({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    minHeight: "553px"
});

const forYouHeaderContentPositioner = css({
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "100%",
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    transform: "translate(-50%, -55%)",
    paddingX: 1.5
});

const forYouImageCss = css({
    "& img": {
        height: "100%",
        maxWidth: "initial"
    }
});

const buttonStyle = css({
    marginTop: 3
});
